import { Pipe, PipeTransform } from "@angular/core";
import { LANGUAGE_ISO_CODES } from "@helpers/constants";

@Pipe({
	name: "lang_to_iso",
	standalone: false
})
export class LanguageToIsoCodePipe implements PipeTransform {
	transform(language: string): string {
		return LANGUAGE_ISO_CODES.get(language) ?? "en";
	}
}
